// @flow
import type { AlertState } from './index'
import * as types from './mutation-types'
import type { AlertMessage } from '../../../types/alert-message'

export default {
  [types.ADD_ALERT_MESSAGE]: (state: AlertState, alertMessage: AlertMessage) => {
    state.alert.dismissed = false
    state.alert.messages.push(alertMessage)
  },

  [types.DISMISS_ALERTS]: (state: AlertState) => {
    state.alert.dismissed = true
    state.alert.messages = []
  },

  [types.SET_ALERT_VIEWED]: (state: AlertState, alertMessage: AlertMessage) => {
    alertMessage.viewed = true
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/alert/mutations.js